module.exports = __webpack_public_path__ + "pc/img/ico-magazine.f46a39d6.svg";